import { styled } from '@mui/system';

const TableWrapper = styled('div')`
  .css-1ou56ah-MuiInputBase-input-MuiInput-input {
    font: 12px Arial, sans-serif !important;
  }
  .css-1pkujop-MuiSelect-select-MuiInputBase-input-MuiInput-input {
    font: 12px Arial, sans-serif !important;
  }
`;

export default TableWrapper;
